export class VoiceFactoryUploadLifecycle {
  constructor(onChange, onError) {
    this.tasks = new Map();
    this.preparations = new Set();
    this.onChange = onChange;
    this.onError = onError;
  }

  isActive() {
    return this.tasks.size > 0 || this.preparations.size > 0;
  }

  beginPreparation() {
    const token = {};
    this.preparations.add(token);
    this.onChange();
    return () => {
      if (this.preparations.delete(token)) this.onChange();
    };
  }

  start(task) {
    if (task.scene !== 3 || !task.files?.length || this.tasks.has(task.datasetId)) return;
    this.tasks.set(task.datasetId, { progress: Promise.resolve() });
    this.onChange();
  }

  enqueueProgress(datasetId, update) {
    const task = this.tasks.get(datasetId);
    if (!task) return;
    // 同一数据集的回写按顺序执行，避免较早的进度覆盖最终完成状态。
    task.progress = task.progress.then(update).catch((error) => {
      this.onError({ datasetId, error: error.message || "上传进度同步失败" });
    });
  }

  async settle(datasetId) {
    const task = this.tasks.get(datasetId);
    if (!task) return;
    await task.progress;
    if (this.tasks.get(datasetId) === task) {
      this.tasks.delete(datasetId);
      this.onChange();
      return true;
    }
  }
}

export function registerVoiceFactoryUnloadGuard(manager, target = window) {
  let listening = false;
  const handleBeforeUnload = (event) => {
    if (!manager.hasActiveVoiceFactoryUploads()) return;
    event.preventDefault();
    event.returnValue = "";
  };
  const update = () => {
    const active = manager.hasActiveVoiceFactoryUploads();
    if (active === listening) return;
    listening = active;
    if (active) target.addEventListener("beforeunload", handleBeforeUnload);
    else target.removeEventListener("beforeunload", handleBeforeUnload);
  };
  const unsubscribe = manager.on("VOICE_FACTORY_UPLOAD_STATE", update);
  update();
  return () => {
    unsubscribe();
    if (listening) target.removeEventListener("beforeunload", handleBeforeUnload);
  };
}
